import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Notification from '../Notification/Notification';
import PageHeader from '../PageHeader/PageHeader';
import loader from '../../assets/loading.gif';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      loading: false,
      loginError: false,
      errorMessage: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.loginSuccessCallback = this.loginSuccessCallback.bind(this);
    this.loginFailureCallback = this.loginFailureCallback.bind(this);
  }

  handleChange(event) {
    const state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }

  submitForm(event) {
    event.preventDefault();
    this.setState({
      loading: true,
      loginError: false,
      errorMessage: ''
    });
    this.props.submitLogin(
      this.state.email,
      this.state.password,
      this.loginSuccessCallback,
      this.loginFailureCallback
    );
  }

  loginSuccessCallback() {
    this.setState({
      loading: false,
      loginError: false
    });
  }

  loginFailureCallback(errorMessage) {
    this.setState({
      loading: false,
      loginError: true
    });

    if (errorMessage) {
      this.setState({ errorMessage });
    } else {
      this.setState({
        errorMessage: (<span>We were unable to log you in with these credentials. Do you want to register a&nbsp;
          <a href="https://www.skinny.co.nz/broadband/">new account</a>?</span>)
      });
    }

    this.loginSection.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  render() {
    return (
      <main>
        <PageHeader title={'Login'} />
        <form onSubmit={this.submitForm}>
          <section className="section-half-margin" ref={(section) => { this.loginSection = section; }}>
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <p className="heading-description">Enter your email address and password to login.</p>
                  {this.state.loginError &&
                    <Notification>
                      {this.state.errorMessage}
                    </Notification>
                  }
                  {this.props.resetPasswordSuccess &&
                    <Notification>
                      Your password has been changed successfully.
                    </Notification>
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-sm-5">
                  <div className="form-input-container">
                    <label htmlFor="email">Email address</label>
                    <input
                      className="input form-control autotest-username"
                      name="email"
                      type="email"
                      placeholder="Email address"
                      value={this.state.email}
                      maxLength={80}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-5">
                  <div className="form-input-container">
                    <label htmlFor="password">Password</label>
                    <input
                      className="input form-control autotest-password"
                      name="password"
                      type="password"
                      placeholder="Password"
                      value={this.state.password}
                      maxLength={100}
                      onChange={this.handleChange}
                    />
                  </div>
                  <span className="float-right text-xxs autotest-forgot-password">
                    <Link to="/forgot-password">Forgot your password?</Link>
                  </span>
                </div>
              </div>
            </div>
          </section>
          <section className="section-half-margin">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <button
                    className="btn btn-default autotest-login-button"
                    type="submit"
                    disabled={!this.state.email || !this.state.password || this.state.loading}
                  >
                    {this.state.loading ?
                      <img
                        src={loader}
                        height="20"
                        alt="Loading..."
                        role="presentation"
                      /> : 'Login'}
                  </button>
                </div>
              </div>
            </div>
          </section>
        </form>
      </main>
    );
  }
}

Login.propTypes = {
  submitLogin: PropTypes.func,
  resetPasswordSuccess: PropTypes.bool
};

export default Login;



/** WEBPACK FOOTER **
 ** ./src/components/Login/Login.js
 **/